module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u-Scholarship-Virtual-Fair-2020-5c137d46d3ef6d1e9005152fe04ef419.jpg";